export default __webpack_public_path__ + "static/DSC_0011-b5f7b518db665b79fc84b827e627c5b0.jpg";